import React from 'react';
import { Instagram, Heart, MessageCircle } from 'lucide-react';
import { Language, translations } from '../utils/translations';
const INSTAGRAM_URL = 'https://www.instagram.com/barber/';
const INSTAGRAM_HANDLE = '@barber';
const FEED_IMAGES = [{
  id: 1,
  url: 'https://images.unsplash.com/photo-1585747860715-2ba37e788b70?w=500&q=80',
  alt: 'Haircut 1',
  likes: '124',
  comments: '12'
}, {
  id: 2,
  url: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=500&q=80',
  alt: 'Haircut 2',
  likes: '89',
  comments: '5'
}, {
  id: 3,
  url: 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=500&q=80',
  alt: 'Barber tools',
  likes: '256',
  comments: '24'
}, {
  id: 4,
  url: 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=500&q=80',
  alt: 'Barber shop',
  likes: '167',
  comments: '8'
}, {
  id: 5,
  url: 'https://images.unsplash.com/photo-1593702275687-f8b402bf1fb5?w=500&q=80',
  alt: 'Fade',
  likes: '342',
  comments: '41'
}, {
  id: 6,
  url: 'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=500&q=80',
  alt: 'Beard trim',
  likes: '198',
  comments: '15'
}];
export function InstagramFeed({
  lang
}: {
  lang: Language;
}) {
  const t = translations[lang];
  return <section className="flex flex-col gap-4 rounded-3xl bg-zinc-900 p-5" data-id="element-120" data-mp="2ts0vurrqk4pl">
      <div className="flex items-center justify-between" data-id="element-121" data-mp="2f47h19ah5682">
        <div className="flex items-center gap-3" data-id="element-122" data-mp="2f2mm3ik8zl9o">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-tr from-yellow-400 via-red-500 to-fuchsia-600 p-[2px]" data-id="element-123" data-mp="2jw7mtid86tck">
            <div className="flex h-full w-full items-center justify-center rounded-full bg-zinc-950 border-2 border-zinc-950" data-id="element-124" data-mp="261yasvm8nz0h">
              <Instagram className="h-4 w-4 text-zinc-50" data-id="element-125" data-mp="1w51z6h11mwrp" />
            </div>
          </div>
          <div data-id="element-126" data-mp="2157ss2qvitcf">
            <h3 className="text-[15px] font-bold text-zinc-50" data-id="element-127" data-mp="214y4cjlh8u8u">{t.instagramTitle}</h3>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="text-[13px] font-medium text-zinc-400 hover:text-gold-500 transition-colors" data-id="element-128" data-mp="6ozohvitfmmc">
              {INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>
        
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="rounded-full bg-zinc-800 px-4 py-1.5 text-[13px] font-bold text-zinc-50 transition-colors hover:bg-zinc-700 active:scale-95" data-id="element-129" data-mp="3p3if3gysxe93">
          {t.instagramFollow}
        </a>
      </div>

      <div className="grid grid-cols-3 gap-2" data-id="element-130" data-mp="gl2p2wy0rd76">
        {FEED_IMAGES.map(image => <a key={image.id} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="group relative aspect-square overflow-hidden rounded-xl bg-zinc-800" data-id="element-131" data-mp="bmrfmnbmz4ph">
            <img src={image.url} alt={image.alt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" data-id="element-132" data-mp="2wg4jbm6uaoqk" />
            <div className="absolute inset-0 flex items-center justify-center gap-3 bg-black/0 opacity-0 transition-all duration-300 group-hover:bg-black/60 group-hover:opacity-100" data-id="element-133" data-mp="2w7hkopi0xpav">
              <div className="flex items-center gap-1 text-white" data-id="element-134" data-mp="350l1n7rvoka9">
                <Heart className="h-4 w-4 fill-white" data-id="element-135" data-mp="352fedyszx639" />
                <span className="text-xs font-bold" data-id="element-136" data-mp="39ye7u0t6leaj">{image.likes}</span>
              </div>
              <div className="flex items-center gap-1 text-white" data-id="element-137" data-mp="3ey8xy254tzuj">
                <MessageCircle className="h-4 w-4 fill-white" data-id="element-138" data-mp="3jxlk0ko6j2w2" />
                <span className="text-xs font-bold" data-id="element-139" data-mp="3jx3hj6axbsfp">{image.comments}</span>
              </div>
            </div>
          </a>)}
      </div>
      
      <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="mt-1 flex w-full items-center justify-center gap-2 rounded-xl bg-zinc-800 px-4 py-3 text-[14px] font-bold text-zinc-50 transition-colors hover:bg-zinc-700 active:scale-[0.98]" data-id="element-140" data-mp="1pjayom6smqv1">
        <Instagram className="h-4 w-4" data-id="element-141" data-mp="3p1w56h3dp178" />
        {t.instagramTitle}
      </a>
    </section>;
}